import Vue from 'vue'
import Vuex from 'vuex'
import { Base64 } from 'js-base64';
import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

import createPersistedstate from 'vuex-persistedstate'

Vue.use(Vuex)

let store = new Vuex.Store({
  plugins: [createPersistedstate()],
  state:{
    token: '',
    OutTime: 0,                 // 当前token过期时间
    nickName: '', // 用户昵称
    JsSdk: '',
    NowShop: '',                 // 当前店铺信息
  },
  // 获取store里面的数据 直接获取数据
  getters,
  // 调用store中的方法A来调用方法B改变变量 然后再调用下面的方法
  actions,
  // 用store中的方法改变变量 用于改变数据 设置数据
  mutations
})

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js